import { DialogService, GridButton } from '@eforall/dashboard';
import { SpecialistSignUpAddData } from '@interfaces';
import { SpecialistSignUpAddDialog, } from '../../../specialist-sign-up';
import { AccSessionViewerDialogDataService } from '../../acc-session-viewer-dialog-data.service';



export function getButtons(pageService: AccSessionViewerDialogDataService, dialogService: DialogService) {

	const buttons: GridButton[] = [];

	const addBtn = {
		iconClass: 'fa-regular fa-plus',
		label: 'Add Specialist Sign-up',
		execute: async () => {
			const data = pageService.accSessionDetails();
			if (!data) return;

			const dialogData: SpecialistSignUpAddData = {
				trimesterId: data.trimesterId,
				topicId: data.topicId,
				languageId: data.languageId,
				availableClassStartTimeUTC: data.startUTC,
				availableClassEndTimeUTC: data.endUTC
			}
			await dialogService.showCustom(SpecialistSignUpAddDialog, { data: dialogData }, 600, 550);
			await pageService.reloadData();
		}
	};

	if (!pageService.isReadonly()) {
		buttons.push(addBtn);
	}

	buttons.push({
		iconClass: 'fa-refresh',
		label: 'Refresh',
		execute: async () => { await pageService.reloadData(); }
	});

	return buttons;
}